import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { tokenAction } from '../../redux-stuffs/actions/token_action';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { message } from 'antd';
import Header from '../../components/Header';
import api from '../../api/api';
import withRecoil from '../../withRecoil';
import { accessTokenState } from '../../atoms';
import './Promo.css';

function Promo(props) {
  const [promo, setPromo] = useState('');

  const handlePromo = (e) => {
    setPromo(e.target.value);
  };

  const savePromo = () => {
    const currentPromo = promo?.trim();

    if (!currentPromo) {
      message.error('Please enter a promo code.');
      return;
    }

    if (currentPromo.length > 25) {
      message.error('Promo code is max 25 characters long');
      return;
    }

    const promo_api = `${api.main}/applyPromo`;

    fetch(promo_api, {
      method: 'POST',
      body: JSON.stringify({
        access_token: props.recoilStates.accessTokenState.state,
        promo: currentPromo,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === 104) {
          message.success(
            'Promo Code successfully applied. Your account should now be credited!'
          );
        } else {
          throw new Error(data.message || 'Failed to apply promo code.');
        }
      })
      .catch((error) => {
        message.error(error.message || 'An unexpected error occurred.');
      });

    // Keep behavior same as original: clear input after submit attempt
    setPromo('');
  };

  return (
    <div>
      <Header />
      <div className="promo-wrapper">
        <div className="promo-profile-container">
          <div className="promo-header">
            <button
              onClick={() => props.history.push('/add-to-balance')}
              className="promo-back-button"
              type="button"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 19l-7-7 7-7"
                  stroke="#333"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="8"
                  y1="12"
                  x2="20"
                  y2="12"
                  stroke="#333"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <div className="spare">
              <h2 className="promo-title">Enter Promo Code</h2>
            </div>
          </div>

          <div className="promo-form">
            <div className="promo-form-group">
              <input
                type="text"
                name="promo"
                maxLength={25}
                className="promo-input"
                value={promo}
                onChange={handlePromo}
              />
            </div>
            <div className="spare">
                <p>Maximum 20 characters long</p>
            </div>
            <div className="promo-submit-wrapper">
              <button
                className="action-button btn"
                style={{ marginTop: '10px' }}
                type="button"
                onClick={savePromo}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      tokenAction: tokenAction,
    },
    dispatch
  );

const mapStateToProps = (state) => {
  return {
    token: state.token,
    profile: state.profile,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withRecoil(Promo, [accessTokenState])));
